import React, { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import '../css/table-styles.css'

const ServerLog = ({ }) => {
    const { date } = useParams()

    const [log_date, setLog_date] = useState([]);
    const [display_log_date, setDisplay_log_date] = useState([]);

    const [filter, setFilter] = useState("");
    const [empty, setEmpty] = useState(false);

    const getLog = async () => {
        try {
            const response = await fetch("https://www.beyondcommunityaccess.com/logs", {
                method: "GET",
                headers: { token: localStorage.token, requested_date: date }
            });
            const jsonDataReq = await response.json();
            var values = []

            jsonDataReq.map(line => {
                var log = {}
                log.complete = line;
                log.time = line.substring(0, line.lastIndexOf(":"));
                log.content = line.substring(line.lastIndexOf(":") + 2, line.lastIndexOf('-'));
                log.result = line.substring(line.lastIndexOf('-') + 1);
                values.push(log)

            })
            values.pop()
            // values.reverse() Don't bc it isn't a live list anymore
            values.length == 0 ? setEmpty(true) : setEmpty(false);
            //we do need to sort it tho
            // values.sort((first, second) => {
            //     if (parseInt(first.time.substring(0, 2)) == parseInt(second.time.substring(0, 2))) {
            //         if (parseInt(first.time.substring(3, 5)) == parseInt(second.time.substring(3, 5))) {
            //             if (parseInt(first.time.substring(6, 8)) == parseInt(second.time.substring(6, 8))) {
            //                 return 0;
            //             } else if (parseInt(first.time.substring(6, 8)) > parseInt(second.time.substring(6, 8))) {
            //                 return 1;
            //             } else {
            //                 return -1;
            //             }
            //         } else if (parseInt(first.time.substring(3, 5)) > parseInt(second.time.substring(3, 5))) {
            //             return 1;
            //         } else {
            //             return -1;
            //         }
            //     } else if (parseInt(first.time.substring(0, 2)) > parseInt(second.time.substring(0, 2))) {
            //         return 1;
            //     } else {
            //         return -1;
            //     }
            // })
            setLog_date(values)
            setDisplay_log_date(values)
        } catch (err) {
            console.error("Failed: displaying/sorting server logs");
            console.error(err.message);
        }
    }
    function filter_log() {
        try {

            setDisplay_log_date(log_date.filter(log => {
                var pass = true;
                if (filter != "") {
                    if (!log.complete.toLowerCase().includes(filter.toLocaleLowerCase()))
                        pass = false;
                }
                return pass;
            }))

        } catch (err) {
            console.error("Failed: filtering logs");
            console.error(err.message);
        }
    }

    useEffect(() => {
        getLog();
    }, [date])

    useEffect(() => {
        filter_log()
    }, [filter])

    return (
        <Fragment>
            <div className="container">
                <h1 className="mt-2 d-inline-block">Server Log for {date}</h1>
                <h5 className="ml-2">Filters:</h5>
                <input className="form-control m-1" type="text" placeholder="Contains" value={filter} onChange={e => setFilter(e.target.value)} />
                <Table className="table text-center">
                    <Thead>
                        <Tr>
                            <Th>Time</Th>
                            <Th>Description</Th>
                            <Th>Result</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {/* <Tr>
                        <Td>John</Td>
                        <Td>Doe</Td>
                        <Td>john@example.com</Td>
                    </Tr> */}
                        {display_log_date.map((log, index) => (
                            <Tr key={index}>
                                <Td>{log.time}</Td>
                                <Td>{log.content}</Td>
                                <Td>{log.result}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
                {empty && <p className="text-danger">No logs fit search terms (i.e. either nothing happened today, or your search is too specific). The logs are not live, and only get uploaded at midnight, so check back tomorrow.</p>}
            </div >
        </Fragment>
    );
}

export default ServerLog;

